import Header from "../../components/Header/Header";
import Footer from "../../components/footer/Footer";
import AdminSideBar from "../../components/SideBar/SideBar";

import rightArrow from "../../assets/SetaDireita.svg";

import styles from "./AdminAccount.module.css";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Relatorios from "../AdminRelatorio/AdminRelatorio";

const AdminAccount = () => {
  const { content } = useParams();
  const { t } = useTranslation();
  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState<boolean>(true);
  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(
    window?.innerWidth < 768
  );

  const handleWindowSizeChange = () =>
    setIsSmallScreen(window?.innerWidth < 768);

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);

    return () => window.removeEventListener("resize", handleWindowSizeChange);
  }, []);

  return (
    <>
      <Header
        boxShadow
        mobileMenuActiveState={isMobileMenuVisible}
        toggleMobileMenu={setIsMobileMenuVisible}
        isSmallScreen={isSmallScreen}
      />
      <main className={styles.mainContainer}>
        <section className={styles.sectionContainer}>
          <div className={styles.breadCrumbs}>
            <span>{t("accountMenu.myAccount")}</span>
            <img src={rightArrow} />
            <span className={styles.optionSelected}>
              {t(`accountMenu.${content}`)}
            </span>
          </div>
          {content === "logs" && <Relatorios />}
        </section>

        {(!isSmallScreen || (isSmallScreen && isMobileMenuVisible)) && (
          <aside>
            <AdminSideBar isSmallScreen={isSmallScreen} />
          </aside>
        )}
      </main>
      {!isSmallScreen && <Footer />}
    </>
  );
};

export default AdminAccount;
